import { modals } from  '../../blocks-ui/modals/modals';
import sendUrl from '../../php/send.php';

(function() {

  const form = document.querySelector('.js-support-form');


    form.addEventListener('submit', (e) => {
      e.preventDefault();

      const url = sendUrl;
      const data = new FormData(form);

      data.append('emailTo', process.env.EMAIL_TO);

      fetch((url), {
        method: 'POST',
        body: data
      })
      .then((response) => response.json())
      .then(() => {
        modals.open('success-support-modal');
        form.reset();
      })
      .catch((err) => {
        console.error(err);
      });

    })
})();